import { dataSkipBackward } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSkipBackward = /*#__PURE__*/createIcon(dataSkipBackward)
export default IconSkipBackward
